import axios from "axios";
import { endSession } from "../analitics/track";
import TaskManagerRequest from "./TaskManagerRequest";
import LocatorHttpRequest from "./LocatorHttpRequest";

const getStorage = (key, type = "stirng") => {
  var value = localStorage.getItem(key);
  if (type == "object" && value) {
    value = JSON.parse(value);
  }
  return value;
};

const setStorage = (key, value, type = "string") => {
  if (type == "object") {
    value = JSON.stringify(value);
  }
  localStorage.setItem(key, value);
};

const getAddress = (lat, lng) => {
  return axios
    .get(
      "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
      lat +
      "," +
      lng +
      "&sensor=true&key=AIzaSyC-ahgqsPN7HgQz_2fjWFLlUYzQkI6FHKo"
    )
    .then((success) => {
      const address = success.data.results[0].formatted_address;
      return address;
    })
    .catch((error) => {
      alert(error);
    });
};

const logout = async () => {


  const accountExpiryMessages = getStorage("accountExpiryMessages", "object");
  const remberUser = getStorage("saveMember", "object");
  const backgroundImg = getStorage("background", "string");
  const savedServiceCenter = getStorage("savedServiceCenter", "object");
  const serviceCenter = getStorage("__serviceCenter__", "object");
  const vehicleCardSettings = getStorage("vehicleCardSettings", "object");
  const deviceTKN = getStorage("deviceTKN", "string");
  const twoFactorSessionId = getStorage("twoFactorSessionId", "string");

  endSession();

  // delete firebase push notification token from server
  if(deviceTKN){
    const user = getStorage("__user__", "object");
    await LocatorHttpRequest("/user/web/clear-fcm-token", {token : deviceTKN, type : "web", userId : user?.id});
  }

  localStorage.clear();

  if (remberUser) setStorage("saveMember", remberUser, "object");
  if (backgroundImg) setStorage("background", backgroundImg, "string");
  if (savedServiceCenter)
    setStorage("savedServiceCenter", savedServiceCenter, "object");
  if (serviceCenter) setStorage("__serviceCenter__", serviceCenter, "object");
  if (vehicleCardSettings)
    setStorage("vehicleCardSettings", vehicleCardSettings, "object");
  if (deviceTKN) setStorage("deviceTKN", deviceTKN, "string");
  if (accountExpiryMessages) setStorage("accountExpiryMessages", accountExpiryMessages, "object");
  if (twoFactorSessionId) setStorage("twoFactorSessionId", twoFactorSessionId, "string");
};

const getTwoFactorSessionId = () => {
  let id = getStorage("twoFactorSessionId");
  if (!id) {
    id = `${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
    setStorage("twoFactorSessionId", id);
  }
  return id;
}

export { getStorage, setStorage, getAddress, logout, getTwoFactorSessionId };
